/**
 * @flow
 */
import Box from '@mui/material/Box';
import AddQuestionButton from 'components/@home/drawers/FormDrawer/AddQuestionButton';
import FormDrawerQuestionsEmpty from 'components/@home/drawers/FormDrawer/FormDrawerQuestionsEmpty';
import QuestionForm from 'components/@home/drawers/FormDrawer/QuestionForm';
import React from 'react';
import type { Question } from './Types';

type Props = {
  form: {
    values: { questions: Array<Question> },
    isValid: boolean,
    submitCount: number,
    errors: Object,
  },
  remove: Function,
  push: Function,
};

const FormDrawerQuestions = ({ form: { values, errors }, remove, push }: Props) => {
  const disableAdd = errors?.questions?.some(q => q?.title || q?.options);
  const onAddQuestion = type => {
    const _id = Math.random().toString();
    push({ _id, title: '', type, options: [{ label: '' }] });
  };

  if (values.questions.length === 0) {
    return <FormDrawerQuestionsEmpty onAddQuestion={onAddQuestion} />;
  }

  return (
    <Box sx={{ mt: 4 }}>
      {values.questions.map((question, index) => (
        <QuestionForm key={question._id} index={index} question={question} remove={remove} />
      ))}
      <AddQuestionButton disabled={disableAdd} onAddQuestion={onAddQuestion} />
    </Box>
  );
};

export default FormDrawerQuestions;
